import CategorySelected from 'app/components/category/products/CategorySelected';
import get from 'lodash/get';
import map from 'lodash/map';
import React, { useState } from 'react';
import ElementCheckbox from './categoryElements/CategoryElementCheckbox';
import styles from './CategoryParameters.module.scss';
import lodashFilter from 'lodash/filter';
import indexOf from 'lodash/indexOf';
import { PRODUCT_PARAMETER_BLACKLIST } from '@/constants/ProductConstants';
import filter from 'lodash/filter';

const FullFilterParameters = ({ categoryData, selected, styles, category }) => {
  const [opened, setOpened] = useState([]);

  if (!categoryData) {
    return '';
  }

  const categoryParams = filter(categoryData?.parameters, param => indexOf(PRODUCT_PARAMETER_BLACKLIST, param?.hash) === -1)

  return (
    <aside className={`${styles.fullParameters}`}>
      <CategorySelected
        options={{ disableHeadline: true }}
        className={styles.selectedFilters}
      />
      <div className={styles?.sidebarContent}>
        <div className={styles.grid}>
          <div className={styles.paramList}>
            {map(categoryParams, (parameter, index) => {
              const propsData = {
                //key: `category-${get(parameter, "id")}-${index}`,
                parameter: parameter,
                setOpened: setOpened,
                opened: opened,
                category: category,
                selected: selected,
                options: {
                  styles: styles,
                  hideAll: true,
                  openExclusive: true,
                },
              };

              return (
                <div
                  key={`advanced-parameters-parameter-${parameter?.id}-${index}`}
                >
                  <ElementCheckbox
                    key={`category-${get(parameter, 'id')}-${index}`}
                    {...propsData}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </aside>
  );
};
export default FullFilterParameters;
